import { Button, Grid } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import {
  usaStateListWithCodes,
  patientGenderOptionsList,
} from '../../../data/fhirHumanNameData';
import {
  AutoCompleteWithTopLabel,
  SelectWithTopLabelComponent,
  TextFieldWithTopLabelComponent,
} from '../uiComponent/fhirComponentUi';
import { capitalizeFirstLetter, getZipCodes } from '../../../config/common';
import { ehrAPIBaseService } from '../../../http-common';
import { useDispatch, useSelector } from 'react-redux';
import { setProgress } from '../../../redux/features/progressSlice';
import { useMainFrameDispatch } from '../../MainUIFrame/MainFrame';
import { ACTION_CLOSE_RIGHT_FLOATING_DRAWER } from '../../MainUIFrame/constants';
import { quickAddData } from '../../../redux/features/quickAddDataSlice';
import { GET_COUNTRIES, GET_STATES } from '../../../config/address-helper';
import { generateNotifications } from '../../reusableLogic';
import { useSnackbar } from 'notistack';

const convertNPIObjectToState = ({ npiObject } = {}) => {
  if (!npiObject) return;
  const npiNumber = npiObject?.number;
  const prefix =
    npiObject?.other_names[0]?.prefix || npiObject?.basic?.name_prefix;
  const suffix =
    npiObject?.other_names[0]?.suffix ||
    npiObject?.basic?.credential ||
    npiObject?.basic?.name_suffix;
  const firstName = npiObject?.basic?.first_name;
  const middleName = npiObject?.basic?.middle_name;
  const lastName = npiObject?.basic?.last_name;
  const gender = npiObject?.basic?.gender === 'M' ? 'male' : 'female';
  const workAddressObject = npiObject?.addresses?.filter(
    f => f?.address_purpose === 'LOCATION'
  )?.[0];
  const addressLine1 = workAddressObject?.address_1;
  const addressLine2 = workAddressObject?.address_2;
  const city = workAddressObject?.city;
  const state = usaStateListWithCodes?.filter(
    f => f?.code === workAddressObject?.state
  )?.[0];
  const postalCodeRaw = workAddressObject?.postal_code?.slice(0, 5);
  const postalCode = { code: Number(postalCodeRaw), display: postalCodeRaw };

  const workNumber = workAddressObject?.telephone_number?.replace(/-/g, '');
  const country = workAddressObject?.country_code;
  let tempLicenses = [];
  npiObject?.taxonomies.forEach(taxonomy => {
    if (!tempLicenses.some(s => s.state?.value === taxonomy.state)) {
      tempLicenses.push({
        state: { value: taxonomy.state, label: taxonomy.state },
        licenseType: taxonomy?.state ? 'None' : 'DEA',
        number: taxonomy.license,
      });
    }
  });

  return {
    npiNumber,
    prefix,
    suffix,
    firstName,
    middleName,
    lastName,
    gender,
    addressLine1,
    addressLine2,
    city,
    state,
    postalCode,
    country,
    workNumber,
    tempLicenses,
  };
};

const qualificationSelectList = [
  {
    code: 'BS',
    display: 'Bachelor of Science',
  },
  {
    code: 'MS',
    display: 'Master of Science',
  },
  {
    code: 'MBBS',
    display: 'Bachelor of Medicine and Bachelor of Surgery',
  },
  {
    code: 'MD',
    display: 'Doctor of Medicine',
  },
  {
    code: 'DO',
    display: 'Doctor of Osteopathic Medicine',
  },
];

const FHIRPractitionerQuickAdd = props => {
  const npiObject = props?.npiObject;
  const nmcObject = false;

  const [practitionerState, setPractitionerState] = useState(
    convertNPIObjectToState({ npiObject })
  );
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const workAddressObject = npiObject?.addresses?.filter(
    f => f?.address_purpose === 'LOCATION'
  )?.[0];

  const [originalState, setOriginalState] = useState(
    usaStateListWithCodes?.filter(
      f => f?.code === workAddressObject?.state
    )?.[0]
  );

  const reduxDispatch = useDispatch();
  const selectedVersion = useSelector(
    state => state.changeVersion.selectedVersion
  );

  const quickData = useSelector(state => state.quickAddData);
  const dispatch = useMainFrameDispatch();

  const [zipcodeOptions, setZipcodeOptions] = useState([]);
  const [practitionerStatesList, setPractitionerStatesList] = useState([]);

  const handleOnChange = event => {
    const { name, value } = event?.target;
    if (name === 'npiNumber') {
      const numericValue = value.replace(/\D/g, '');
      setPractitionerState({ ...practitionerState, npiNumber: numericValue });
      return;
    }

    let newValue = value;
    const fieldsToCapitalize = [
      'firstName',
      'lastName',
      'addressLine1',
      'addressLine2',
      'city',
    ];

    if (fieldsToCapitalize.includes(name)) {
      newValue = capitalizeFirstLetter(newValue);
    }

    setPractitionerState({
      ...practitionerState,
      [name]: newValue,
    });
  };

  useEffect(() => {
    setZipcodeOptions([
      ...getZipCodes(
        practitionerState?.state?.code
          ? practitionerState?.state?.code
          : // : usaStateListWithCodes.length
          // ? usaStateListWithCodes[0]?.code
          selectedVersion == 'IN'
          ? 'AN'
          : 'AL',
        practitionerState?.country?.slice(0, 2)?.toUpperCase()
      ),
    ]);
    if (practitionerState?.state?.code !== originalState?.code) {
      setPractitionerState({ ...practitionerState, postalCode: undefined });
      setOriginalState(practitionerState?.state);
    }
  }, [practitionerState?.state?.code]);

  // useEffect(() => {
  //   setPractitionerState({
  //     ...practitionerState,
  //     state: undefined,
  //     postalCode: undefined,
  //   });
  //   setPractitionerStatesList(
  //     GET_STATES(practitionerState?.country?.slice(0, 2)?.toUpperCase())
  //   );
  // }, [practitionerState?.country]);

  // useEffect(() => {
  //   setPractitionerState({
  //     ...practitionerState,
  //     state: undefined,
  //     postalCode: undefined,
  //   });
  //   setPractitionerStatesList(
  //     GET_STATES(practitionerState?.country?.slice(0, 2)?.toUpperCase())
  //   );
  // }, [practitionerState?.country]);

  const nmcRef = useRef(null);

  const npiRef = useRef(null);
  const addressLine1Ref = useRef(null);
  const stateRef = useRef(null);
  const postalcodeRef = useRef(null);
  const workNumberRef = useRef(null);
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const genderRef = useRef(null);
  const emailRef = useRef(null);
  const cityRef = useRef(null);
  const qualificationRef = useRef(null);
  const countryRef = useRef(null);

  useEffect(() => {
    console.log(`BBX`, practitionerState);
  }, [practitionerState]);

  const firstNameValidationObject = {
    name: 'firstName',
    value: practitionerState?.firstName,
    label: 'First Name',
    validation: {
      required: true,
    },
    ref: firstNameRef,
  };

  const middleNameValidationObject = {
    name: 'middleName',
    value: practitionerState?.middleName,
    label: 'Middle Name',
  };

  const lastNameValidationObject = {
    name: 'lastName',
    value: practitionerState?.lastName,
    label: 'Last Name',
    validation: {
      required: true,
    },
    ref: lastNameRef,
  };

  const genderValidationObject = {
    name: 'gender',
    value: practitionerState?.gender,
    label: 'Gender',
    optionsList: patientGenderOptionsList,
    ref: genderRef,
    validation: {
      required: false,
    },
  };

  const ValidationObject1 = selectedVersion => {
    let name;
    let value;
    let ref;
    let label;
    let validation;
    let mask;
    let maxLength;

    if (selectedVersion === 'IN') {
      name = 'nmcNumber';
      value = practitionerState?.nmcNumber;
      label = 'NMC Number';
      ref = nmcRef;
      validation = {
        required: true,
        disabled: nmcObject ? true : false,
      };
    } else {
      name = 'npiNumber';
      value = practitionerState?.npiNumber;
      label = 'NPI Number';
      ref = npiRef;
      validation = {
        required: true,
        min: 10,
        max: 10,
        disabled: npiObject ? true : false,
      };

      mask = '9999-99-9999';
      maxLength = 10;
    }

    return {
      name,
      value,
      label,
      ref,
      validation,
      mask,
      maxLength,
    };
  };

  const addressLine1ValidationObject = {
    name: 'addressLine1',
    value: practitionerState?.addressLine1,
    label: 'Address Line 1',
    validation: {
      required: true,
    },
    ref: addressLine1Ref,
  };

  const addressLine2ValidationObject = {
    name: 'addressLine2',
    value: practitionerState?.addressLine2,
    label: 'Address Line 2',
  };

  const cityValidationObject = {
    name: 'city',
    value: practitionerState?.city,
    label: selectedVersion === 'IN' ? 'City/District/Village' : 'City',
    validation: {
      required: true,
    },
    ref: cityRef,
  };

  const stateValidationObject = {
    name: 'state',
    value: practitionerState?.state || usaStateListWithCodes?.[0],
    // value: practitionerState?.state || '',
    label: 'State',
    optionsList: usaStateListWithCodes,
    // optionsList: practitionerStatesList,
    validation: {
      required: true,
    },
    ref: stateRef,
  };

  const postalCodeValidationObject = {
    name: 'postalCode',
    value: practitionerState?.postalCode || { code: '', display: '' },
    label: 'Zip Code',
    optionsList: zipcodeOptions,
    validation: {
      required: true,
    },
    ref: postalcodeRef,
  };

  const workNumberValidationObject = {
    name: 'workNumber',
    value: practitionerState?.workNumber,
    label: 'Home Phone',
    validation: {
      required: true,
      min: 10,
      max: 10,
      pattern: /^[0-9]+$/,
    },
    mask: '(999) 999-9999',
    ref: workNumberRef,
    maxLength: 10,
  };

  const workEmailValidationObject = {
    name: 'email',
    value: practitionerState?.email,
    label: 'Email',
    validation: {
      // required: true,
      // min: 2,
      // max: 500,
      pattern: /^\w+([.+]?\w+)*@\w+([.+]?\w+)*(\.\w{2,3})+$/,
    },
    ref: emailRef,
  };

  const qualificationValidationObject = {
    name: 'qualificationObject',
    value: practitionerState?.qualificationObject,
    label: 'Qualification',
    optionsList: qualificationSelectList,
    ref: qualificationRef,
    validation: {
      required: false,
    },
  };

  const countryValidation = {
    name: 'country',

    value: practitionerState?.country?.slice(0, 2)?.toUpperCase() || 'US',
    label: 'Country',
    ref: countryRef,
    width: '100%',
    // optionsList: GET_COUNTRIES(),
    optionsList: [
      selectedVersion == 'IN'
        ? { code: 'IN', display: 'India' }
        : // : { code: 'usa', display: 'USA' },
          { code: 'US', display: 'USA' },
    ],
    validation: {
      required: true,
    },
  };

  const generatePractitionerFHIRObject = () => {
    const qualificationObject = [];
    if (practitionerState?.qualificationObject?.display) {
      qualificationObject.push({
        code: {
          coding: [
            {
              system: 'http://terminology.hl7.org/CodeSystem/v2-0360/2.7',
              code: practitionerState?.qualificationObject?.code,
              display: practitionerState?.qualificationObject?.display,
            },
          ],
          text: practitionerState?.qualificationObject?.display,
        },
        period: {
          start: '1995',
        },
        issuer: {
          display: 'University',
        },
      });
    }

    // qualificationObject.code.coding[0].code =
    //   practitionerState?.qualificationObject?.code;
    // qualificationObject.code.coding[0].display =
    //   practitionerState?.qualificationObject?.display;
    // qualificationObject.code.text =
    //   practitionerState?.qualificationObject?.display;
    debugger;
    if (
      practitionerState?.tempLicenses?.filter(f => f.licenseType !== 'DEA')
        .length
    ) {
      practitionerState?.tempLicenses
        ?.filter(f => f.licenseType !== 'DEA')
        ?.forEach(license => {
          qualificationObject.push({
            code: {
              coding: [
                {
                  system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
                  code: 'SL',
                  display: 'State License Number',
                },
              ],
              text: 'State License Number',
            },
            identifier: [
              {
                system: 'http://example.com/identifier/state-license',
                value: JSON.stringify([
                  license?.number,
                  license?.secondary_number,
                ]),
              },
            ],
            extension: [
              {
                url: 'http://example.com/extension/state',
                valueString: license?.state?.value,
              },
            ],
          });
        });
      if (
        practitionerState?.tempLicenses.filter(f => f.licenseType === 'DEA')
          .length
      ) {
        practitionerState?.tempLicenses
          .filter(f => f.licenseType === 'DEA')
          .map(license => {
            qualificationObject.push({
              code: {
                coding: [
                  {
                    system: 'http://example.com/identifier/dea-license',
                    code: 'DEA',
                    display: 'DEA',
                  },
                ],
                text: 'DEA',
              },
              identifier: [
                {
                  system: 'http://example.com/identifier/dea-license',
                  value: license?.number,
                },
              ],
              issuer: {
                display: 'DEA',
              },
            });
          });
      }
    }

    const addressWork = {
      city: practitionerState?.city,
      country:
        practitionerState?.country === 'US'
          ? 'USA'
          : practitionerState?.country,
      line: [
        practitionerState?.addressLine1 || '',
        practitionerState?.addressLine2 || '',
      ],
      postalCode: practitionerState?.postalCode?.display,
      state: practitionerState?.state?.code || usaStateListWithCodes?.[0]?.code,
      type: 'postal',
      use: 'home',
    };
    let identifierNPIObj = {
      use: 'usual',
      type: {
        coding: [
          {
            system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
            code: selectedVersion === 'IN' ? 'NMC' : 'NPI',
            userSelected: false,
          },
        ],
      },
      system: 'http://hl7.org/fhir/sid/us-ssn',
      value:
        selectedVersion === 'IN'
          ? practitionerState?.nmcNumber
          : practitionerState?.npiNumber,
    };
    let telecom = [
      {
        system: 'phone',
        use: 'home',
        value: practitionerState?.workNumber,
      },
      {
        system: 'email',
        use: 'home',
        value: practitionerState?.email,
      },
    ];
    let payload = {
      active: true,
      address: [addressWork],
      name: [
        {
          family: practitionerState?.lastName,
          given: [
            practitionerState?.firstName,
            practitionerState?.middleName || '',
            practitionerState?.lastName,
          ],
          prefix: [
            practitionerState?.prefix === '--'
              ? ''
              : practitionerState?.prefix
              ? practitionerState?.prefix
                  .substring(0, practitionerState?.prefix.length - 1)
                  .toLowerCase()
              : '',
          ],
          suffix: [
            practitionerState?.suffix === '--' ? '' : practitionerState?.suffix,
          ],
          text: `${practitionerState?.firstName} ${
            practitionerState?.middleName || ''
          } ${practitionerState?.lastName}`,
          use: 'official',
        },
      ],
      gender: practitionerState?.gender,
      resourceType: 'Practitioner',
      identifier: [identifierNPIObj],
      telecom,
      qualification: qualificationObject,
    };

    return payload;
  };

  const handleOnClick = async event => {
    debugger;
    const { name } = event?.target;
    if (name === 'create') {
      const fnValid = firstNameRef?.current?.onValidate();
      const lnValid = lastNameRef?.current?.onValidate();
      const genderValid = genderRef?.current?.onValidate();
      const validateObject = selectedVersion === 'IN' ? nmcRef : npiRef;
      const npiValid = validateObject?.current?.onValidate();
      const workNumberValid = workNumberRef?.current?.onValidate();
      const emailValid = emailRef?.current?.onValidate();
      const al1Valid = addressLine1Ref?.current?.onValidate();
      const cityValid = cityRef?.current?.onValidate();
      const stateValid = stateRef?.current?.onValidate();
      const postalCodeValid = postalcodeRef?.current?.onValidate();
      const qualificationValid = qualificationRef?.current?.onValidate();
      const countryValid = countryRef?.current?.onValidate();

      if (
        !fnValid?.valid ||
        !lnValid?.valid ||
        // !genderValid?.valid ||
        !npiValid?.valid ||
        !workNumberValid?.valid ||
        !emailValid?.valid ||
        !al1Valid?.valid ||
        !cityValid?.valid ||
        !stateValid?.isValid ||
        !postalCodeValid?.isValid ||
        // !qualificationValid?.isValid
        !countryValid?.valid
      ) {
        return;
      }
      let message = '';
      let description = '';
      const payload = generatePractitionerFHIRObject();
      try {
        reduxDispatch(setProgress(true));
        const response = await ehrAPIBaseService.post(
          `fhir/createResource`,
          payload
        );
        debugger;
        reduxDispatch(
          quickAddData({
            ...quickData,
            display: response?.data?.name[0]?.text,
            label: response?.data?.name[0]?.text,
            value: `${response?.data?.resourceType}/${response?.data?.id}`,
            code: `${response?.data?.resourceType}/${response?.data?.id}`,
            raw: response.data,
          })
        );
        // ref.current.getQuickAddData({
        //     display: response?.data?.name[0]?.text,
        //     label: response?.data?.name[0]?.text,
        //     value: `${response?.data?.resourceType}/${response?.data?.id}`,
        //     code: `${response?.data?.resourceType}/${response?.data?.id}`,
        //     raw: response.data,
        // })
        if (props?.setRefresh) {
          props?.setRefresh(!props?.refresh);
        }
        if (typeof props?.practitionerData === 'function')
          props?.practitionerData({
            taxonomies: npiObject?.taxonomies,
            ...response?.data,
          });
        if (typeof props?.setNPI === 'function')
          props?.setNPI({
            isSelected: true,
            data: {
              taxonomies: npiObject?.taxonomies,
              ...response?.data,
            },
          });

        debugger;
        if (props?.handleQuickAddClose) {
          props?.handleQuickAddClose();
        } else {
          dispatch({
            type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
          });
        }
        message = 'Practitioner Created Successfully';
        description = 'Practitioner Created Successfully';
        // dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
      } catch (e) {
        console.error(e);
        message = 'Error while creating practitioner';
        description = 'Error while creating practitioner';
      } finally {
        reduxDispatch(setProgress(false));
        generateNotifications({
          title: message,
          descriptions: description,
          enqueueSnackbar,
          closeSnackbar,
          reduxDispatch,
        });
      }
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...firstNameValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...middleNameValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...lastNameValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <SelectWithTopLabelComponent
          onChange={handleOnChange}
          {...genderValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...ValidationObject1(selectedVersion)}
        />
      </Grid>
      <Grid item sm={12}>
        <AutoCompleteWithTopLabel
          onChange={handleOnChange}
          {...qualificationValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...workNumberValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...workEmailValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...addressLine1ValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...addressLine2ValidationObject}
        />
      </Grid>

      <Grid item sm={12}>
        <SelectWithTopLabelComponent
          onChange={handleOnChange}
          {...countryValidation}
        />
      </Grid>

      <Grid item sm={12}>
        <AutoCompleteWithTopLabel
          onChange={handleOnChange}
          {...stateValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <TextFieldWithTopLabelComponent
          onChange={handleOnChange}
          {...cityValidationObject}
        />
      </Grid>
      <Grid item sm={12}>
        <AutoCompleteWithTopLabel
          onChange={handleOnChange}
          from={'practitionerCreate'}
          {...postalCodeValidationObject}
          organizationState={practitionerState}
          of={props?.of}
          // forOnly={'fhirOrganizationQuickAdd'}
        />
      </Grid>
      <Grid item sm={12}>
        <Button
          fullWidth
          name="create"
          onClick={handleOnClick}
          variant="outlined"
        >
          Create practitioner
        </Button>
      </Grid>
      <Grid item sm={12}>
        <Button
          fullWidth
          variant="outlined"
          color="error"
          onClick={() => {
            if (props?.handleQuickAddClose) {
              props?.handleQuickAddClose();
            } else {
              dispatch({
                type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
              });
            }
          }}
        >
          Cancel
        </Button>
      </Grid>
    </Grid>
  );
};

export default FHIRPractitionerQuickAdd;
